export default __webpack_public_path__ + "static/media/logomd.2eecc66d.png";